import React from 'react';
import { connect } from 'react-redux';
import Store from '../../common/models/Store';
import Row from '../UI/Row';
import { ExtendedFooterBox } from '../ExtendedFooterBox/ExtendedFooterBox';
import { infoBoxCopy } from './InfoBoxCopy';
import { Desktop } from '../MediaQuery/index';
import withCountryCode from '../RoutesHoc/RoutesHoc';

/* Components */
const ItalistInfoBoxesComponent: React.ComponentType<{
  buildUrlWithCountry?: (url: string) => string;
  s3BasePath: string;
}> = ({ buildUrlWithCountry, s3BasePath }) => {
  const infoBoxContent = infoBoxCopy(buildUrlWithCountry, s3BasePath);
  return (
    <>
      <Desktop>
        <Row>
          <hr className="divider" />
        </Row>
      </Desktop>
      <div className="info-boxes-container">
        {infoBoxContent.map(content => (
          <ExtendedFooterBox color="#F25C5E" padding="0 20px" text={content.text} title={content.title}>
            {content.icons && (
              <div className="icons-container">
                <div
                  style={{
                    overflow: 'hidden',
                    width: '50px',
                  }}
                >
                  <a
                    href="https://www.bbb.org/us/ca/los-angeles/profile/online-retailer/italistcom-1216-902411"
                    rel="noopener noreferrer"
                    target="_blank"
                  >
                    <img
                      alt="italist.com, Online Retailer, Los Angeles, CA"
                      src="https://seal-sanjose.bbb.org/logo/ruvtbul/italistcom-902411.png"
                      style={{ height: '95px', width: '100px' }}
                    />
                  </a>
                </div>
                <div>
                  <div className="icons-row">
                    {content.icons.map(icon => (
                      <div>
                        {' '}
                        <img src={icon.src} style={{ ...icon.style }} />
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            )}
          </ExtendedFooterBox>
        ))}
      </div>
      <Desktop>
        <Row margin="0 0 50px 0">
          <hr className="divider" />
        </Row>
      </Desktop>
      <style jsx>
        {`
          .info-boxes-container {
            display: flex;
            width: 100%;
            max-width: 1280px;
            min-height: 258px;
            margin: 35px auto 25px;
          }

          @media (max-width: 1023px) {
            .info-boxes-container {
              flex-direction: column;
            }
          }

          @media (min-width: 1024px) {
            .info-boxes-container {
              flex-direction: row;
            }
          }

          .divider {
            display: flex;
            flex: 1;
            width: 100%;
            max-width: 1280px;
            margin: 18px auto;
            border: solid 2px #eeeef0;
          }

          .icons-container {
            display: flex;
            flex-direction: row;
            padding: 0 90px;
            margin-top: 10px;
          }

          .icons-row {
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            justify-content: space-between;
            margin-left: 10px;
            width: 80px;
          }
        `}
      </style>
    </>
  );
};

const mapStateToProps = ({ api: { s3BasePath } }: Store) => ({ s3BasePath });

export const ItalistInfoBoxes = withCountryCode(connect(mapStateToProps)(ItalistInfoBoxesComponent));
